import { FunctionComponent } from 'react'
import classnames from 'classnames'

import { getInitials } from 'utilities/string.util'

const Avatar: FunctionComponent<{
  name: string | null | undefined
  size?: 'sm' | 'md' | 'lg'
  className?: string
}> = ({ name, size = 'md', className }) => (
  <span
    className={classnames('avatar', size === 'sm' && 'avatar-sm', className)}
    style={size === 'lg' ? { width: 48, height: 48, fontSize: 16 } : undefined}
    aria-hidden="true"
  >
    {getInitials(name)}
  </span>
)

export default Avatar
